import React, { Component } from "react"

/* Modal */
import Modal from 'react-modal'

class ArrayFilter extends Component {

    constructor() {
        super()
        this.state = {
            filter: false
        }
    }

    change = (id) => {

        const { activeList, setList } = this.props
        let tempActiveList = activeList

        const i = activeList.findIndex(e => e === id)

        if (i === -1) {
            tempActiveList.push(id)
        } else {
            tempActiveList.splice(i, 1)
        }

        console.log(tempActiveList)

        setList(tempActiveList)

    }


    /* Draw Filter Modal */
    _filter = () => {

        /* Fields */
        const { filter } = this.state
        const { list, activeList, apply } = this.props

        return (
            <Modal
                isOpen={filter}
                onRequestClose={() => this.setState({ filter: false })}
                className={`header-array-filter-modal`}
                overlayClassName="header-array-filter-overlay"
                closeTimeoutMS={200}
            >

                <div className="header-array-filter-header">
                    <h2>Выберите категории</h2>
                    <div onClick={() => this.setState({ filter: false })} className="header-array-filter-close">
                        <img src="/images/close.png" alt="Close" />
                    </div>
                </div>

                <div className="header-array-filter-container">

                    <div className="header-array-filter-container-inner">

                        {/* Dates */}
                        <div className="header-array-filter-list">
                            {list.map((item, index) => {
                                const i = activeList.findIndex(e => e === item.id)
                                return (
                                    <div onClick={() => this.change(item.id)} className={`header-array-filter-item ${i} ${i !== -1 ? 'active' : 'default'}`} key={`${index}`}>{item.name}</div>
                                )
                            })}
                        </div>

                    </div>

                    {/* Bottom */}
                    <div className="header-array-filter-bottom">
                        <div onClick={() => this.setState({ filter: false })} className="header-array-filter-button cancel">Отменить</div>
                        <div onClick={() => apply()} className="header-array-filter-button">Применить</div>
                    </div>

                </div>

            </Modal>
        )
    }

    render = () => {

        const { activeList } = this.props

        return (
            <>
                <div onClick={() => this.setState({ filter: true })} className="header-array-filter">
                    <p>Категории</p>
                    <div className="header-array-filter-text">
                        <div className="header-array-filter-text-value">{activeList.length}</div>
                    </div>
                </div>
                {this._filter()}
            </>
        )

    }

}

export default ArrayFilter